// Written by Claude Code on 2026-04-21
// User prompt: NavContext for passing state between internal pages
// Written by Codex on 2026-10-16
// User prompt: Fix leave case refresh and browser history navigation.
import React, { createContext, useContext, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { casePagePath, caseStateFromPath } from '../utils/caseNavigation';

const NavContext = createContext(null);

export function NavProvider({ onNavigate, children }) {
  const location = useLocation();
  const [transientState, setTransientState] = useState(null);
  // Persist identifiers only. Case data is fetched again through authenticated,
  // tenant-scoped APIs; a URL never grants permission to read the case.
  const isCasePage = /^\/app\/leave-case(?:\/|$)/.test(location.pathname);
  const navState = isCasePage ? caseStateFromPath(location.pathname) : transientState;
  const navigate = useCallback((page, state = null) => {
    setTransientState(page === 'leave-case' ? null : state);
    onNavigate(page === 'leave-case' ? casePagePath(state) : page);
  }, [onNavigate]);
  const clearNavState = useCallback(() => setTransientState(null), []);
  return (
    <NavContext.Provider value={{ navigate, navState, clearNavState }}>
      {children}
    </NavContext.Provider>
  );
}
export function useNav() { return useContext(NavContext); }
